import ConnectionRefused from '@package/components/ErrorPages/ConnectionRefused/ConnectionRefused';

export default ConnectionRefused;
